import { createContext } from "react";

export const ConsultClinicianClientsContext = createContext<any>([]);
